import React from 'react'
import style from './CardProductOutput.module.css'
const CardProductOutput = ({ checked, handleOnChange, expeditionDate, expirationDate,stock,name,code, id,index=0 }) => {
    return (
        <div className={style.card_container}>
            <div className={style.card}>
                <div>Lote {name}:{code}</div>
                <div>Fecha expedición {new Date(expeditionDate).toLocaleDateString()}</div>
                <div>Fecha expiración {new Date(expirationDate).toLocaleDateString()}</div>
                <div>Stock {stock}</div>
            </div>
            <label className={style.radio_container}>

                <input 
                checked ={checked}
                className={style.checkmark} type="checkbox" name="batch"
                    onChange={handleOnChange}
                    value={id}
                />
                <span className={style.checkmark}>{checked && (index+1)} </span>
            </label>

        </div>
    )
}

export default CardProductOutput
